import type { fabric } from 'fabric';
import type { Editor } from '../editor/editor';
import { $ } from './dom';
import { GRIP_GAP, GRIP_SIZE } from '../editor/handleRules';

/**
 * Small duplicate / lock / delete bar that floats above the selected object (below it near the top edge).
 * With several chosen it also offers "รวมกลุ่ม", with a group chosen "แยกกลุ่ม" (`groupState`, src/ui/objectActions.ts).
 */
export function initSelBar(ed: Editor, groupState: () => 'group' | 'ungroup' | null) {
  const { canvas } = ed;
  const bar = $('selbar');
  const gBtn = $('sGroup');
  let shown: string | null = '';
  function syncGroup() {
    const s = groupState();
    if (s === shown) return;
    shown = s;
    gBtn.hidden = !s;
    gBtn.textContent = s === 'group' ? 'รวมกลุ่ม' : 'แยกกลุ่ม';
    gBtn.setAttribute('aria-label', s === 'group' ? 'รวมชิ้นที่เลือกเป็นกลุ่ม' : 'แยกกลุ่ม');
  }
  let transforming = false;

  function place() {
    const o = canvas.getActiveObject();
    if (!o || transforming || (o as fabric.IText).isEditing) { bar.hidden = true; return; }
    bar.hidden = false;
    syncGroup();
    const r = o.getBoundingRect(); // viewport coordinates = CSS px over the canvas
    const bw = bar.offsetWidth, bh = bar.offsetHeight, gap = 18;
    const W = canvas.getWidth(), H = canvas.getHeight();
    let top = r.top - bh - gap;
    // below the piece: keep clear of the ✥ grip a tiny piece has there (src/editor/handles.ts)
    const below = o.isControlVisible('grip') ? GRIP_GAP + GRIP_SIZE / 2 + 8 : gap;
    if (top < 8) top = r.top + r.height + below;
    if (top + bh > H - 8) top = Math.max(8, H - bh - 8);
    const left = Math.min(Math.max(8, r.left + r.width / 2 - bw / 2), W - bw - 8);
    bar.style.left = `${Math.round(left)}px`;
    bar.style.top = `${Math.round(top)}px`;
  }

  const hide = () => { transforming = true; bar.hidden = true; };
  canvas.on('object:moving', hide);
  canvas.on('object:scaling', hide);
  canvas.on('object:rotating', hide);
  canvas.on('mouse:up', () => { transforming = false; place(); });
  canvas.on('after:render', place);
  canvas.on('selection:cleared', () => { bar.hidden = true; });
}
